import React from "react";
import { TextTitle } from "ui/text";
import { DirectionalButton } from "ui/button";
import { Box, Flex, SimpleGrid } from "@chakra-ui/react";
import { Rule } from "ui/rule";
import { type Customer } from "lib/sanity";
import { FillImage } from "components/images";

type CaseStudyExample = {
  customer: Customer;
  chipText: string;
  title: string;
  description: string;
};

export function CaseStudyExamples({ examples }: { examples: CaseStudyExample[] }) {
  return (
    <SimpleGrid
      columns={{ base: 1, md: 3 }}
      gap={{ base: "huge", md: "bigger" }}
      maxW={{
        base: "100%",
        sm: "cardMaxW", // Only cap width from sm to md breakpoint so the single column doesn't look as silly there
        md: "100%",
      }}
    >
      {examples.map((ex) => (
        <Flex key={ex.customer.slug} flexDir="column">
          <TextTitle
            maxW="100%"
            flex={1}
            titleAs="h3"
            size="xs"
            chip={{ text: ex.chipText, variant: "gray" }}
            title={ex.title}
            description={ex.description}
            actions={
              <DirectionalButton variant="secondary" href={`/customers/${ex.customer.slug}`} p="0">
                Learn more
              </DirectionalButton>
            }
          />

          <Rule />

          <Box width="120px" height="24px" maxW="100%" maxH="100%" pos="relative">
            <FillImage
              placeholder="empty"
              src={`${ex.customer.logoUrl}?w=200`}
              alt={`${ex.customer.name} logo.`}
              style={{ objectFit: "contain", objectPosition: "left" }}
            />
          </Box>
        </Flex>
      ))}
    </SimpleGrid>
  );
}
